(function () {
  "use strict";

  class ViewProductButton extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes() {
      return ["product"];
    }

    get product() {
      return this._product;
    }

    set product(value) {
      this._product = value;
      this.render();
    }

    connectedCallback() {
      if (this._product) {
        this.render();
      }
    }

    async render() {
      this.innerHTML = `
<div class="rcc-search__view-product"><a href="${this._product.url}">View Product</a></div>
        `;
    }
  }

  customElements.define("rcc-view-product-button", ViewProductButton);
})();
